import type { PoseVitima } from './rigVitima'

/**
 * Colar Cervical de Resgate (imobilização raquimedular).
 *
 * Utilizado para restringir os graus de liberdade da coluna cervical da vítima,
 * impedindo flexão, extensão, inclinação lateral e torção axial.
 *
 * Quando aplicado:
 * 1. Mantém a cabeça rigidamente alinhada ao eixo longitudinal do tronco (em bloco).
 * 2. Neutraliza o efeito chicote gerado pela oscilação da suspensão do veículo.
 * 3. Garante que durante o giro de extração (30°, 60°, 90°) o pescoço não pague a rotação.
 */
export interface EstadoColarCervical {
  colocado: boolean
  tamanho: 'padrao' | 'adultoPequeno' | 'adultoGrande'
}

export const ESTADO_COLAR_PADRAO: EstadoColarCervical = {
  colocado: false,
  tamanho: 'padrao',
}

/**
 * Aplica a restrição anatômica do colar cervical sobre a pose da vítima.
 * Se o colar estiver colocado, a cabeça é travada em alinhamento neutro com o tronco.
 */
export function aplicarColarCervical(pose: PoseVitima, colocado: boolean): PoseVitima {
  if (!colocado) return pose

  return {
    ...pose,
    cabecaInclinacaoRad: 0,
    cabecaTorcaoRad: 0,
  }
}

/**
 * Avalia o fator de proteção cervical conferido pelo colar.
 * Retorna um multiplicador de sobrecarga residual (1.0 = sem proteção, 0.15 = protegido).
 */
export function fatorProtecaoColar(colocado: boolean): number {
  return colocado ? 0.15 : 1.0
}

